export default function handleSubtitleFontSize(subtitleFontSizeStyle, styles) {
  switch (subtitleFontSizeStyle) {
    case "small":
      return styles._font_size_small;
    case "medium":
      return styles._font_size_medium;
    case "large":
      return styles._font_size_large;
  }
}
